import React from 'react';
import './style.scss';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closePopup } from '../../Modal/action';

const ForceLogout = (props) => {
    const {forceLogout, verifyKYC, payloadForForceLogout, payloadForVerifyKyc, closePopup} = props;

    const onSubmit = async () => {
        await forceLogout(payloadForForceLogout);
        await verifyKYC(payloadForVerifyKyc);
        closePopup();
    }

    return(
        <div>
            <div className="info">
                <p>Your previous session is still active.</p>
                <p>Do you want to cancel the previous session and login again?</p>
                <button className='submit no' onClick={closePopup}>No</button>
                <button className='submit' onClick={() => onSubmit()}>Yes</button>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
    closePopup: bindActionCreators(closePopup, dispatch),
});

const ForceLogoutContainer = connect(mapStateToProps, mapDispatchToProps)(ForceLogout);

export default ForceLogoutContainer;